import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=6560a0e9&scoped=true"
import script from "./editDialog.vue?vue&type=script&lang=js"
export * from "./editDialog.vue?vue&type=script&lang=js"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=6560a0e9&prod&lang=scss&scoped=true"
import style1 from "./editDialog.vue?vue&type=style&index=1&id=6560a0e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6560a0e9",
  null
  
)

export default component.exports